import { render, staticRenderFns } from "./order-item-box.vue?vue&type=template&id=a80982e8&scoped=true&"
import script from "./order-item-box.vue?vue&type=script&lang=js&"
export * from "./order-item-box.vue?vue&type=script&lang=js&"
import style0 from "./order-item-box.vue?vue&type=style&index=0&id=a80982e8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80982e8",
  null
  
)

export default component.exports